import { useTranslation } from 'react-i18next';
import { navLinks, WEB_LINK } from '../../constants';
import LangSwitcher from '../../main-parts/lang';
import BurgerLatest from '../../main-parts/burger-latest';
import { useEffect, useState } from 'react';
import { Clock, Mail, MapPin, Phone } from 'lucide-react';
import { m } from 'framer-motion';
import { CustomLink } from '../../main-parts/link';

const Header = () => {
  const { t } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);

  const handleScroll = () => {
    setIsScrolled(window.scrollY >= 150);
  };
  const isSticky = () => {
    const header = document.querySelector('.header-section');
    const scrollTop = window.scrollY;

    if (header) {
      if (scrollTop >= 150) {
        header.classList.add('is-sticky');
      } else {
        header.classList.remove('is-sticky');
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', isSticky);
    return () => {
      window.removeEventListener('scroll', isSticky);
    };
  });

  useEffect(() => {
    handleScroll();
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <header
      className={`fixed top-0 left-0 duration-300 ${isScrolled ? 'bg-title-color/95' : 'backdrop-blur'} w-full pt-3 shadow-xl z-30`}
    >
      <div className="container">
        <div className="flex items-center justify-between gap-x-3">
          <CustomLink
            to={'/'}
            className="flex text-3xl pb-3 font-bold text-white-color"
          >
            <span>ESM</span>
            <span className={`text-primary`}>.</span>
          </CustomLink>
          <div className="flex flex-col flex-1">
            <div className="flex items-center">
              <div className="flex flex-1 lg:justify-center justify-end lg:gap-x-5 gap-x-4 md:pl-[7.5%]">
                <CustomLink
                  to={`tel:${WEB_LINK.phone}`}
                  className="flex items-center gap-x-2 text-white-color duration-200 hover:opacity-80 active:scale-95"
                >
                  <span>
                    <Phone size={18} />
                  </span>
                  <span className="flex">
                    {WEB_LINK.phone}
                  </span>
                </CustomLink>
                <CustomLink
                  to={`mailto:${WEB_LINK.email}`}
                  className="sm:flex hidden items-center gap-x-2 text-white-color duration-200 hover:opacity-80 active:scale-95"
                >
                  <span>
                    <Mail size={18} />
                  </span>
                  <span className="lg:flex hidden">{WEB_LINK.email}</span>
                </CustomLink>
                <CustomLink
                  to={WEB_LINK.map_url}
                  className="flex items-center gap-x-2 text-white-color duration-200 hover:opacity-80 active:scale-95"
                >
                  <span>
                    <MapPin size={18} />
                  </span>
                  <span className="md:flex hidden">
                    {t(WEB_LINK.map_title)}
                  </span>
                </CustomLink>
                <div className="lg:hidden flex relative">
                  <BurgerLatest />
                </div>
              </div>
              <div className="lg:flex hidden items-center gap-x-2 text-white-color text-base">
                <span>
                  <Clock size={18} />
                </span>
                <span>{t(WEB_LINK.work_week.time)}:</span>
                <span>{WEB_LINK.work_hours}</span>
              </div>
            </div>
            <div className="h-[1.5px] rounded-full bg-gradient-to-r from-transparent to-white/30 to-75% my-3"></div>
            <div className="flex flex-1 lg:justify-between justify-end">
              <div className="lg:flex hidden gap-x-6 pb-3 justify-center flex-1">
                {navLinks.map((el, i) => (
                  <CustomLink
                    key={i}
                    to={el.path}
                    className="flex items-center gap-x-2 text-white-color  text-base w-max active:scale-95 duration-200 relative before:absolute before:bottom-0 before:-left-full before:h-[3px] before:bg-primary before:w-full pb-[2px] overflow-x-hidden before:duration-300 hover:before:left-0"
                  >
                    {t(el.title)}
                  </CustomLink>
                ))}
              </div>
              <div className="flex items-center">
                <div className="flex md:hidden items-center mr-3 pr-3 border-r-2 border-gray-200/50 gap-x-2 mb-3 text-white-color text-base">
                  <span>
                    <Clock size={18} />
                  </span>
                  <span>5/7:</span>
                  <span>{WEB_LINK.work_hours}</span>
                </div>
                <LangSwitcher />
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
